module.exports = __webpack_public_path__ + "img/cpxl-m-icon.967f3b36.png";